/*
 *   File : primary.js
 *   Author : https://evoqins.com
 *   Description : CTA component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo } from "react";
import "../../Style/Components/primary.scss";
import Icon from "../icons";

const Button = (props) => {
  return (
    <button
      className={`custom-button e-primary-font-poppins ${props.ClassName} ${
        props.disabled ? " opacity-50" : " "
      }`}
      data-bs-toggle={props.toggle}
      data-bs-target={props.target}
      data-bs-cancel={props.cancel}
      data-bs-dismiss={props.dismiss}
      disabled={props.disabled}
      id={props.id}
      onClick={(e) => {
        if (props.loading) return;
        props.onPress(e);
      }}
    >
      {props.loading ? (
        <span
          className="spinner-border spinner-border-sm"
          aria-hidden="true"
        ></span>
      ) : (
        <>
          {props.type === 2 ? (
            <>
              {props.name}
              {props.icon && (
                <Icon
                  icon={props.icon}
                  size={props.size ? props.size : "20px"}
                  className="me-2"
                />
              )}
            </>
          ) : (
            <>
              {props.icon && (
                <Icon
                  icon={props.icon}
                  size={props.size ? props.size : "20px"}
                  className={props.name ? "me-2" : "m-0"}
                />
              )}
              {props.name}
            </>
          )}
        </>
      )}
    </button>
  );
};

Button.defaultProps = {
  onPress: () => {},
  className: null,
  id: null,
  name: null,
  icon: null,
};

export default memo(Button);
